export const stackedList = 'flex flex-col gap-1 pb-2 mt-4';
export const absentWarning =
  'm-3 bg-uiBg absolute bottom-16 ml-auto z-10 px-5 py-5 bg-white text-textMid w-11/12 rounded-2xl';
export const fadButton = 'm-3 bottom-14 z-10 px-3.5 py-2.5';
export const addPractitioners = 'absolute bottom-1 z-20';
export const dropdownStyles = 'w-11/12 left-4';
export const absentCard = 'w-11/12 bg-uiBg rounded-xl mt-4';
export const absentCardTitle = 'mt-6 ml-4';
export const absentCardSubTitle = 'mt-4 ml-4';
